// @ts-nocheck



import { createAction, createSlice } from '@reduxjs/toolkit';
import { journalApi } from '../lib/api';
import { defaultPageSize } from './constants';





export const FETCH_JOURNALS = 'vehicles/journals/fetch';
export const SET_FILTER = 'vehicles/journals/set-filter';
export const CLEAN_FILTER = 'vehicles/journals/clean-filter';













type JournalsState = {
  data: any[];
  page: number;
  pageSize: number;
  totalCount: number;
  filters: Record<string, unknown>;
};

const initialState: JournalsState = {
  data: [],
  page: 1,
  pageSize: defaultPageSize,
  totalCount: 0,
  filters: {}
};

const fetchJournalsAction = createAction<{
  data: any[];
  totalCount: number;
  page: number;
  pageSize: number;
}>(FETCH_JOURNALS);
const setFilterAction = createAction<Record<string, unknown>>(SET_FILTER);
const cleanFilterAction = createAction(CLEAN_FILTER);

const journalsSlice = createSlice({
  name: 'vehicles/journals',
  initialState: initialState as JournalsState,
  reducers: {},
  extraReducers: (builder) => {
    builder.
    addCase(fetchJournalsAction, (state, { payload }) => ({
      ...state,
      ...payload
    })).
    addCase(setFilterAction, (state, { payload }) => ({
      ...state,
      filters: payload
    })).
    addCase(cleanFilterAction, (state) => ({
      ...state,
      filters: {}
    }));
  }
});

export const journalsActions = {
  fetch: fetchJournalsAction,
  setFilter: setFilterAction,
  cleanFilter: cleanFilterAction
};

export const fetchJournals = (
page = 1,
params = {}) =>
async (dispatch, getState) => {
  const { filters, pageSize } = getState().journals;
  const { data, totalCount } = await journalApi.fetchJournals({
    ...filters,
    page,
    pageSize,
    orderBy: 'created',
    byDescending: true,
    ...params
  });
  dispatch(
    journalsActions.fetch({
      data,
      totalCount,
      page,
      pageSize
    })
  );
};

export const applyFilters = (filters) => (
dispatch) =>
{
  dispatch(journalsActions.setFilter(filters));
  dispatch(fetchJournals());
};

export const cleanFilters = () => async (dispatch) => {
  dispatch(journalsActions.cleanFilter());
  dispatch(fetchJournals());
};

export default journalsSlice.reducer;
